import { HttpInterceptorFn, HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ElofizetoCegService } from '../../services/elofizeto-ceg.service';

export const selectedCegInterceptor: HttpInterceptorFn = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
) => {
    const elofizetoCegService = inject(ElofizetoCegService);
    const selectedCegGuid = elofizetoCegService.getSelectedCeg();

    if (selectedCegGuid) {
        const clonedRequest = req.clone({
            setHeaders: { 'X-Selected-Ceg-Guid': selectedCegGuid }
        });
        return next(clonedRequest);
    }

    return next(req);
};
